import { queryOptions } from "@tanstack/react-query";
import { apiFetch } from "@/api/client";
import type { Account } from "@/schemas/models/account";

export const accountKeys = {
  all: () => ["account"] as const,
};

export const accountQueries = {
  detail: () =>
    queryOptions({
      queryKey: [...accountKeys.all(), "detail"] as const,
      queryFn: () => apiFetch<Account>("/api/account"),
      staleTime: Infinity,
      gcTime: Infinity,
    }),
};
